export const createErrorObject = (response)=>({
        status: response.status || 500,
        errorCode: 'internal-server-error',
        message: 'Unexpected error occurred',
        responseHeaders: response.xhr.getAllResponseHeaders()
    });
